module.exports = __webpack_public_path__ + "media/images/flags/4x3/blz-152abd8d9f99774456f1e3410a0c6cc3.svg";